<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Upload COI</h3>
    <p class="modal-subtitle mb-0">
      @if (InsuranceAgentName) {
        For {{ InsuranceAgentName }}.
      }
      Drag a file in, or browse from your machine. Accepts .pdf, .jpg, .jpeg,
      and .png.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="coi-dropzone">
    <app-file-upload-file-display
      [layout]="'vertical'"
      [displayNoScanButton]="false"
      [fileInfoDisplayType]="'minimal'"
      [hideSelectFileButton]="true"
      [removeFileButtonText]="'Delete'"
      [Files]="COIFiles"
      (FileEvent)="fileUpload($event)"
      (removeFileEvent)="removeFile($event)"
    >
    </app-file-upload-file-display>
  </div>

  <div class="form-group mb-0 coi-scan">
    <label class="form-label" for="coiScanDropdown">Scan type</label>
    <select
      id="coiScanDropdown"
      class="form-select"
      (change)="onScanCOIChange($event)"
    >
      <option selected value="">No scan</option>
      @for (option of scanTypeOptions; track $index) {
        <option value="{{ option.value }}">{{ option.label }}</option>
      }
    </select>
    <p class="coi-scan__hint mb-0">
      Pick a scan to auto-extract the policy from a single file. Leave on "No
      scan" to upload multiple files at once.
    </p>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      Save COI
    </button>
  </div>
</div>
